import { z } from "zod";

export const loginSchema = z.object({
	email: z
		.string()
		.min(1, { message: "E-mail é obrigatório" })
		.email({ message: "Digite um e-mail válido" }),
	password: z.string().min(1, { message: "Senha é obrigatória" }),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
